var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plate_text cursor-pointer",class:{ highlighted: _vm.selected },on:{"click":function($event){return _vm.$emit('click', _vm.plate_code)}}},[_c('span',{style:(_vm.getPercentStyle(_vm.pct))},[_vm._v(_vm._s(_vm.plate_name+" "+_vm.c_num))])])
}
var staticRenderFns = []

export { render, staticRenderFns }